import aiApiClient from '../../../../cms/src/apiClient/ai-api-client';
import { Dropdown, Space, Typography, message } from 'antd';
import React, { useMemo, useState, useCallback } from 'react';
import { useApplyTransactionInRange } from '../../hooks';
import { EllipsisOutlined } from '@ant-design/icons';
import { useEditorState } from '@remirror/react';
import CommandButton from '../CommandButton';

export const TranslateIcon = React.memo(() => {
  return (
    <>
      <svg
        role="graphics-symbol"
        viewBox="0 0 16 16"
        className="aiTranslate"
        style={{ width: '16px', height: '16px', display: 'block', fill: 'rgb(68, 131, 97)', flexShrink: '0' }}
      >
        <g>
          <path d="M0.990263 11.9374C1.50923 11.9374 1.80048 11.6727 1.98582 11.0266L2.2453 10.2111H4.86129L5.12077 11.0584C5.29023 11.6833 5.58149 11.9374 6.14281 11.9374C6.70943 11.9374 7.11719 11.5509 7.11719 11.0054C7.11719 10.8042 7.08012 10.6241 6.9901 10.3753L5.089 5.19623C4.79775 4.4019 4.33174 4.06299 3.53212 4.06299C2.77486 4.06299 2.30355 4.41779 2.02289 5.19623L0.137684 10.3753C0.0529553 10.6083 0 10.8466 0 11.0107C0 11.5879 0.375982 11.9374 0.990263 11.9374ZM2.63188 8.74423L3.50034 5.79992H3.54271L4.43765 8.74423H2.63188Z"></path>
          <path d="M9.92506 8.57591C9.38887 8.91351 9.12077 9.32393 9.12077 9.80717C9.12077 10.0653 9.18035 10.2672 9.29951 10.4129C9.42528 10.5519 9.59739 10.6214 9.81584 10.6214C9.82908 10.6214 9.84563 10.6214 9.86549 10.6214C9.88535 10.6148 9.89859 10.6115 9.9052 10.6115C9.96478 10.6115 9.99457 10.5817 9.99457 10.5221V8.6057C9.99457 8.55274 9.9714 8.54281 9.92506 8.57591ZM12.3776 7.97021C12.0864 7.97021 11.805 7.99007 11.5336 8.02979C11.4807 8.04303 11.4542 8.07282 11.4542 8.11915V9.68801C11.4542 9.70125 11.4608 9.71118 11.4741 9.7178C11.4939 9.72442 11.5072 9.72111 11.5138 9.70787C11.9441 9.25773 12.3081 8.70499 12.606 8.04965C12.6126 8.02979 12.6093 8.01324 12.5961 8C12.5829 7.98014 12.5663 7.97021 12.5464 7.97021H12.3776ZM9.64704 11.9718C9.03141 11.9718 8.53493 11.7931 8.15761 11.4356C7.78691 11.0781 7.60156 10.5916 7.60156 9.97597C7.60156 9.30738 7.80346 8.71492 8.20726 8.19859C8.61106 7.67564 9.18366 7.27846 9.92506 7.00705C9.9714 6.98719 9.99457 6.95078 9.99457 6.89783V6.03396C9.99457 5.981 9.96809 5.95452 9.91513 5.95452H8.6243C8.47205 5.95452 8.33966 5.89826 8.22712 5.78572C8.11459 5.67319 8.05832 5.54079 8.05832 5.38854V5.2396C8.05832 5.08735 8.11459 4.95496 8.22712 4.84242C8.33966 4.72989 8.47205 4.67362 8.6243 4.67362H9.91513C9.96809 4.67362 9.99457 4.64714 9.99457 4.59418V4.17715C9.99457 4.02489 10.0508 3.89581 10.1634 3.7899C10.2759 3.67736 10.4083 3.62109 10.5606 3.62109H10.8882C11.0405 3.62109 11.1729 3.67736 11.2854 3.7899C11.3979 3.89581 11.4542 4.02489 11.4542 4.17715V4.59418C11.4542 4.64714 11.484 4.67362 11.5436 4.67362H14.9792C15.1314 4.67362 15.2638 4.72989 15.3764 4.84242C15.4889 4.95496 15.5452 5.08735 15.5452 5.2396V5.38854C15.5452 5.54079 15.4889 5.67319 15.3764 5.78572C15.2638 5.89826 15.1314 5.95452 14.9792 5.95452H11.5436C11.484 5.95452 11.4542 5.981 11.4542 6.03396V6.58008C11.4542 6.62642 11.4807 6.64959 11.5336 6.64959C11.7719 6.62311 12.0533 6.60987 12.3776 6.60987C13.5427 6.60987 14.4364 6.86473 15.0586 7.37444C15.6875 7.87754 16.0019 8.56598 16.0019 9.43978C16.0019 10.1216 15.7934 10.7174 15.3764 11.2271C14.9659 11.7302 14.3966 12.0976 13.6685 12.3293C13.5228 12.3756 13.3805 12.359 13.2415 12.2796C13.1025 12.2002 13.0098 12.0843 12.9635 11.9321L12.8741 11.6541C12.8278 11.515 12.841 11.3793 12.9138 11.2469C12.9867 11.1079 13.0959 11.0086 13.2415 10.9491C13.6188 10.7902 13.92 10.575 14.1451 10.3036C14.3702 10.0322 14.4827 9.74428 14.4827 9.43978C14.4827 9.00288 14.3437 8.66197 14.0657 8.41704C14.0326 8.38394 14.0028 8.39718 13.9763 8.45676C13.5063 9.57548 12.8807 10.4427 12.0996 11.0583C11.3251 11.6673 10.5076 11.9718 9.64704 11.9718Z"></path>
        </g>
      </svg>
    </>
  );
});

const prepareTranslatePayload = ({ selectedText, sourceId, translation }) => ({
  action: { type: 'translation' },
  source_id: sourceId,
  source: { value: selectedText },
  target: { tone: 'formal', language: translation },
});

export const TranslateButton = React.memo(({ fileId }) => {
  const { updateContentInRange, deleteSelection } = useApplyTransactionInRange();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const editorState = useEditorState();

  const onClickHandler = useCallback(
    ({ key }) => {
      if (loading) return;
      setIsOpen(false);
      setLoading(true);
      const { from, to } = editorState.selection;
      if (from && to) {
        const selectedText = editorState.doc.slice(from, to).toString();
        aiApiClient
          .post('/ai/documents/actions', prepareTranslatePayload({ selectedText, sourceId: fileId, translation: key }))
          .then((response) => {
            const { chat_response } = response || {};
            if (chat_response?.content) {
              deleteSelection();
              updateContentInRange({ from, content: chat_response?.content });
            }
          })
          .catch((error) => {
            console.log(error);
            message.error('Unable to improve writing due to server error.');
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
    [editorState, deleteSelection, updateContentInRange, fileId]
  );

  const items = useMemo(
    () => [
      { key: 'english', label: 'English', onClick: () => onClickHandler?.('english') },
      { key: 'hindi', label: 'हिंदी', onClick: () => onClickHandler?.('hindi') },
    ],
    [onClickHandler]
  );

  return (
    <Dropdown
      destroyPopupOnHide
      open={isOpen}
      onOpenChange={() => setIsOpen(!isOpen)}
      overlayClassName="toolbar__button__dropdown"
      className={`toolbar__button`}
      menu={{ items }}
      trigger={['click']}
      placement="bottomLeft"
    >
      <CommandButton icon={<TranslateIcon />} loading={loading}>
        <Space>
          <Typography.Text className="command__button-text weight-normal">Translate</Typography.Text>
          <EllipsisOutlined />
        </Space>
      </CommandButton>
    </Dropdown>
  );
});

export default TranslateButton;
